import { Component } from '@angular/core';
import { WebsiteConfigReviewsSelectComponent } from './website-config-reviews-select/website-config-reviews-select.component';
import { WebsiteConfigReviewsOrderComponent } from './website-config-reviews-order/website-config-reviews-order.component';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { trigger, transition, style, animate } from '@angular/animations';
import { CommonModule } from '@angular/common';

export enum ReviewMode {
  Select = 'select',
  Order = 'order',
}

@Component({
  selector: 'app-website-config-reviews',
  standalone: true,
  imports: [
    WebsiteConfigReviewsSelectComponent,
    WebsiteConfigReviewsOrderComponent,
    MatButtonToggleModule, CommonModule
  ],
  animations: [
    trigger('fadeInOut', [
      transition(':enter', [
        style({ opacity: 0 }),
        animate('300ms 0s', style({ opacity: 1 }))
      ]),
      transition(':leave', [
        animate('300ms 0s', style({ opacity: 0 }))
      ])
    ])
  ],
  templateUrl: './website-config-reviews.component.html',
  styleUrl: './website-config-reviews.component.scss',
})
export class WebsiteConfigReviewsComponent {
  public selectedComponent: ReviewMode = ReviewMode.Select;
  public reviewMode = ReviewMode;

  public onToggleChange(selectedValue: ReviewMode): void {
    this.selectedComponent = selectedValue;
  }
}
